import { PlaceWithGTTParams } from "../commons/interface";
import api from "./api";

export async function getTrades() {
  try {
    const response = await api.get("/trades");
    return response.data;
  } catch (error) {
    console.error("Failed to fetch trades", error);
    return [];
  }
}

export async function fetchBalance() {
  try {
    const response = await api.get("/trades/balance");
    return response.data;
  } catch (error) {
    console.error("Error fetching the balance", error);
    return [];
  }
}

export const placeGTTOrder = async (params: PlaceWithGTTParams) => {
  try {
    const response = await api.post("/trades/placeGTT", params);
    return response.data;
  } catch (error) {
    console.error(`Error placing GTT order for ${params.symbol}`, error);
  }
};

export async function placeTrade(
  symbol: string,
  instrumentKey: string,
  quantity: number,
  entryPrice: number,
  target: number,
  stopLoss: number,
  side: "BUY" | "SELL"
) {
  try {
    const response = await api.post("/trades/place", {
      symbol,
      instrumentKey,
      quantity,
      entryPrice,
      target,
      stopLoss,
      side,
    });
    return response.data;
  } catch (error) {
    console.error("Trade placement failed", error);
  }
}

export async function closeTrade(tradeId: string) {
  try {
    const response = await api.post(`/trades/close/${tradeId}`);
    return response.data;
  } catch (error) {
    console.error("Trade closing failed", error);
  }
}
